import {Injectable} from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class ArrayService {
  /**
   * Sorts an Array of objects by an array of strings.
   *
   * @param objectArr Objects to sort
   * @param stringArr strings to sort the objects by
   * @param attributeToSortBy Name of the attribute of the object to sort by.
   */
  static sortObjectsArrayByStringArray(objectArr: any[], stringArr: string[], attributeToSortBy: string): any[] {
    objectArr.sort((a, b) => {
      const index1: number = stringArr.indexOf(a[attributeToSortBy]);
      const index2: number = stringArr.indexOf(b[attributeToSortBy]);
      return (index1 > -1 ? index1 : Infinity) - (index2 > -1 ? index2 : Infinity);
    });
    return objectArr;
  }

  /**
   * Moves an item of an array from oldIndex to newIndex.
   *
   * @param arr Array to change.
   * @param oldIndex current position of the item.
   * @param newIndex new position of the itme.
   */
  static moveArrayItem(arr: any[], oldIndex: number, newIndex: number) {
    if (newIndex >= arr.length) {
      let k: number = newIndex - arr.length + 1;
      while (k--) {
        arr.push(undefined);
      }
    }
    arr.splice(newIndex, 0, arr.splice(oldIndex, 1)[0]);
    return arr;
  }

  /**
   * Calculates the difference between two arrays.
   *
   * @param getDifferenceArray The additional entries in this Array will be returned.
   * @param compareToArray Array to compare to array1 with.
   */
  static calcDifference(getDifferenceArray: any[], compareToArray: any[]) {
    return getDifferenceArray.filter((x) => !compareToArray.includes(x));
  }

  static filterInPlace(array: any[], predicateFunction: any): any[] {
    let from: number = 0;
    let to: number = 0;
    while (from < array.length) {
      if (predicateFunction(array[from])) {
        array[to] = array[from];
        to++;
      }
      from++;
    }
    array.length = to;
    return array;
  }

  static removeDuplicates(array: any[]): any[] {
    return [...new Set(array)];
  }
}
